import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTableAdvanced from "../../../../components/HilightTableAdvanced";
import Moment from "react-moment";
import SelectFilter from "../../../../components/FilterField/SelectFilter";
import ActivityFilterModel from "../_filters/ActivityFilterModel";
import {hilightTableAdvancedService} from "../../../../services/hilight-table-advanced.service";
import DateRangeFilter from "../../../../components/FilterField/DateRangeFilter";
import {Spinner} from "react-bootstrap";
import moment from "moment";

const ActivityLogsTable = ({t, refresh = null}) => {

    const fetchIdRef = React.useRef(0);

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [itemCount, setItemCount] = React.useState(0);
    const [filters, setFilters] = React.useState([]);

    const [operationSummary, setOperationSummary] = React.useState(null);
    const [unlockSummary, setUnlockSummary] = React.useState(null);
    const [requestUrlParams, setRequestUrlParams] = React.useState({});
    const [columns, setColumns] = React.useState([]);

    const apiUrl = `/api/logs/GetContentLogs`;

    React.useEffect(() => {
        ActivityFilterModel.getApiFilter().then((res) => {
            setFilters(res);
            setColumns([
                {
                    Header: 'hash',
                    accessor: 'id',
                    disableFilters: true
                },
                {
                    Header: 'appName',
                    accessor: 'appName',
                    Filter: SelectFilter,
                    filterOptions: res['appNames']
                },
                {
                    Header: 'action',
                    accessor: 'actionName',
                    Filter: SelectFilter,
                    filterOptions: res['actions']
                },
                {
                    Header: 'insert-data',
                    accessor: 'insertDate',
                    Filter: DateRangeFilter,
                    Cell: (props) => {
                        const data = props.row.original;
                        return <Moment format="YYYY-MM-DD HH:mm:ss">{data.insertDate}</Moment>
                    }
                },
                {
                    Header: 'metrics',
                    accessor: 'metrics'
                }
            ]);
        })
    },[]);


    const fetchData = React.useCallback(({urlParams, pageSize}) => {
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        if (fetchId === fetchIdRef.current) {
            hilightTableAdvancedService.getHilightTableRequest(apiUrl, urlParams)
                .then((resultData) => {
                    setRequestUrlParams(urlParams);
                    setData(resultData.logs);
                    setLoading(false);
                    setItemCount(resultData.allItemsCount);
                    setPageCount(Math.ceil(resultData.allItemsCount / pageSize));
                    setOperationSummary(resultData.operationSummary);
                    setUnlockSummary(resultData.unlockSummary);
                });
        }
    }, []);

    return (
        <div className="col-md-12 mx-0 my-3 p-0">

            {operationSummary ? (
                <div className="row mt-2">
                    <div className="col-md-12">
                        <h5>{t('power-on-times')}</h5>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="info-box">
                        <span className="info-box-icon bg-green">
                            <i className="fas fa-check"/>
                        </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-wrap">{t('correctIntervalsCount')}</span>
                                <span className="info-box-number">{operationSummary.correctIntervalsCount}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="info-box">
                        <span className="info-box-icon bg-red">
                            <i className="fas fa-times"/>
                        </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-wrap">{t('brokenItemsCount')}</span>
                                <span className="info-box-number">{operationSummary.brokenItemsCount}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="info-box">
                        <span className="info-box-icon bg-blue">
                            <i className="fas fa-clock"/>
                        </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-wrap">{t('durationMinutes')}</span>
                                <span className="info-box-number">
                                    {moment.duration(operationSummary.durationMinutes, "minutes").format("hh:mm")} [godziny i minuty]
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            ) : (<Spinner animation="border"/>)}

            {unlockSummary ? (
                <div className="row">
                    <div className="col-md-12">
                        <h5>{t('interactive-times')}</h5>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="info-box">
                        <span className="info-box-icon bg-green">
                            <i className="fas fa-check"/>
                        </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-wrap">{t('correctIntervalsCount')}</span>
                                <span className="info-box-number">{unlockSummary.correctIntervalsCount}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="info-box">
                        <span className="info-box-icon bg-red">
                            <i className="fas fa-times"/>
                        </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-wrap">{t('brokenItemsCount')}</span>
                                <span className="info-box-number">{unlockSummary.brokenItemsCount}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-4">
                        <div className="info-box">
                        <span className="info-box-icon bg-blue">
                            <i className="fas fa-clock"/>
                        </span>
                            <div className="info-box-content">
                                <span className="info-box-text text-wrap">{t('durationMinutes')}</span>
                                <span className="info-box-number">
                                    {moment.duration(unlockSummary.durationMinutes, "minutes").format("hh:mm")} [godziny i minuty]
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            ) : (
                <Spinner animation={"border"}/>
            )}

            {filters && columns ? (
                <HilightTableAdvanced
                    columns={columns}
                    data={data}
                    fetchData={fetchData}
                    loading={loading}
                    pageCount={pageCount}
                    itemCount={itemCount}
                    filterModel={ActivityFilterModel}
                />
            ) : (<></>)}
        </div>
    )
};
export default withNamespaces()(ActivityLogsTable);
